var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-6 c"},[_c('div',{staticClass:"card card-body text-center"},[_c('h2',[_vm._v("جاري الدخول...")])])])}]

export { render, staticRenderFns }